import type {ModalDialogService} from 'shared/modal-dialogs';
import type {Fond} from 'src/typings';
import type {FieldsDefinitionsDataService} from 'src/features/record-editation/field7-and-field8-editors/fields-definitions-data.service';
import type {
    Field7EditorModalModel
} from 'src/features/record-editation/field7-and-field8-editors/field7-editor-modal/types';

export class Field7ValueEditorService {
    public static serviceName = 'field7ValueEditorService';


    /*@ngInject*/
    constructor(private modalDialogService: ModalDialogService, private fieldsDefinitionsDataService: FieldsDefinitionsDataService) {
    }

    public async editModelFunction(model: string, editParams: Field7EditorAdditionalOptions): Promise<string> {
        const definitions = await this.fieldsDefinitionsDataService.getField007Definitions();

        const modalModel: Field7EditorModalModel = {value: model, fond: editParams.fond, definitions};
        return this.modalDialogService.openModalWindowAndGetPayload('field7Editor', modalModel);
    }
}

interface Field7EditorAdditionalOptions {
    fond: Fond;
}

